class pgweb.HelpDialog

	@register: (dialogId, buttonId) ->
		$('body').off 'click', '#'+buttonId
		$('body').on 'click', '#'+buttonId, ->
			$('#'+dialogId).fadeToggle 'fast'

		$('body').off 'click', '.help-box button'
		$('body').on 'click', '.help-box button', ->
			$(this).closest('.help-box').fadeToggle 'fast'
